// Filter raw provider listModels() responses down to chat-completion-capable
// model ids. Used by `UnifiedInterface.listChatModels` so every consumer gets
// the same filtered list regardless of which transport (direct SDK / worker
// proxy) produced the raw payload.

// Only substrings that overlap with the prefix regex need to be excluded.
// gpt-image-1 (image gen), gpt-3.5-turbo-instruct (legacy completions),
// gpt-4o-*-realtime-preview (realtime API, not Chat Completions),
// gpt-4o-*-transcribe (audio transcription endpoint, not chat).
// gpt-4o-audio-preview and gpt-4o-search-preview ARE Chat Completions models — keep them.
const OPENAI_NON_CHAT_SUBSTRINGS = ['image', 'instruct', 'realtime', 'transcribe']
const OPENAI_CHAT_PREFIX = /^(gpt-|o\d|chatgpt-)/

const isOpenaiChatModel = (id: string): boolean => {
  if (!OPENAI_CHAT_PREFIX.test(id)) return false
  return !OPENAI_NON_CHAT_SUBSTRINGS.some(s => id.includes(s))
}

const filterOpenai = (raw: any): string[] => {
  const ids: string[] = (raw?.data || []).map((m: any) => m?.id).filter((id: any) => !!id)
  return Array.from(new Set(ids.filter(isOpenaiChatModel))).sort()
}

const filterGemini = (raw: any): string[] => {
  const ids: string[] = (raw?.models || [])
    .filter(
      (m: any) =>
        Array.isArray(m?.supportedGenerationMethods) &&
        m.supportedGenerationMethods.includes('generateContent'),
    )
    .map((m: any) => String(m?.name || '').replace(/^models\//, ''))
    .filter((id: string) => id && !id.includes('embedding') && !id.includes('aqa'))
  return Array.from(new Set(ids)).sort()
}

const filterOllama = (raw: any): string[] => {
  const ids: string[] = (raw?.models || [])
    .map((m: any) => m?.name || m?.model || '')
    .filter((id: string) => !!id)
  return Array.from(new Set(ids)).sort()
}

export function filterChatModels(provider: string, raw: unknown): string[] {
  if (provider === 'openai') return filterOpenai(raw)
  if (provider === 'gemini') return filterGemini(raw)
  if (provider === 'ollama') return filterOllama(raw)
  throw new Error(`Unsupported provider: ${provider}`)
}
